import en from './en.json'
import zhCN from './zh-CN.json'

export default {
    en,
    'zh-CN': zhCN,
}